import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ProductCard from "../../../../../../common/common_card/ProductCard";
import "./Explore_Other_Products.css";
import { getProducts } from "../../../../../../../utils/apis/effects/Effects";
import { Context } from "../../../../../../../utils/context";
import { IDS } from "../../../../../../../utils/common";
import { useNavigate } from "react-router-dom";
const products = [
  {
    id: 1,
    title: "SQUALL CO2/ T-SHIRT CANNON",
    image: "/assets/images/effects/img1.png",
  },
  {
    id: 2,
    title: "T-SHIRT GATLING GUN",
    image: "/assets/images/effects/img2.png",
  },
  { id: 3, title: "CREEPER AQ", image: "/assets/images/effects/img3.png" },
  { id: 4, title: "DRY ICE MACHINE", image: "/assets/images/effects/img4.png" },
];

export default function Explore_Other_Products({effectId}) {

  const navigate = useNavigate();

   const [product, setProduct] = useState([]);
    const firstFour = product.slice(0, 4);
    const restProducts = product.slice(4);
  
    const { IMG_URL } = useContext(Context);
  
    const getProduct = async () => {
  const res = await getProducts(effectId); //works for both cases
  if (res?.success) {
    setProduct(res.data);
  }
};  


    useEffect(() => {
      getProduct();
    }, [effectId]);

    const handleServiceClick = (id) => {
    navigate(`/product/${id}`);
  };


  return (
    <div className="Explore_Other_Products-section product-page-section">
      <div className="container">
        <h1 className="page-title">Explore Other Products</h1>
        <Row className="g-3">
          {product.map((item) => (
            <Col key={item.id} xl={3} lg={3} md={4} xs={6}>
              <ProductCard
                title={item?.name}
                image={IDS?.IMG_URL + item.image}
                // onClick={() => navigate("/product-details")}
                onClick={() => handleServiceClick(item?.id)}
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
